//  // Updated landing page React component matching design from uploaded PNG
import { HomePageAssets } from "../assets/homePageIcons";
import Header from "../components/Header";
import { useScrollAnimation } from "../hooks/useScrollAnimation";

export default function LandingPage() {
  const discoverSection = useScrollAnimation();
  const easyAccessSection = useScrollAnimation();
  const supportCreatorsSection = useScrollAnimation();
  const dreamTeamSection = useScrollAnimation();
  const artistProfileSection = useScrollAnimation();
  const getPaidSection = useScrollAnimation();
  const gridSection = useScrollAnimation();
  const finalCTASection = useScrollAnimation();
  return (
    <div className="relative w-full min-h-screen text-white overflow-x-hidden animate-fade-in" >
      {/* Background image */}
      <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none select-none bg-cover bg-center bg-no-repeat bg-[#0a0a0f]" style={{backgroundImage: `url(${HomePageAssets.background})`, backgroundAttachment: 'fixed'}} />


      {/* Main Content Container - max width 988px for md to lg screens (768px-1640px) */}
      <div className="w-full md:max-w-[1640px] md:mx-auto lg:max-w-none 2xl:max-w-[2600px] 2xl:mx-auto">

      {/* NAVBAR */}
      <Header />

      {/* HERO SECTION */}
      <section className="flex flex-col items-start text-left md:items-center md:text-center px-6 pt-28 relative">
        {/* ICONS STRUCTURE */}
        <div className="relative w-full flex flex-col items-center justify-center">
          {/* Left icon */}
          <div className="hidden xl:block absolute left-0 top-1/2 -translate-y-1/2 lg:left-[18rem] lg:mt-[4rem] ">
 
              <img src={HomePageAssets.icon3} alt="Headphones"   />
            
          </div>
          {/* Right icon */}
          <div className="hidden xl:block absolute right-0 top-1/2 -translate-y-1/2 lg:right-72 ">
 
              <img src={HomePageAssets.icon1} alt="Location"  />
 
          </div>
          {/* Bottom-right icon */}
          <div className="hidden xl:block absolute right-24 bottom-0 translate-y-1/2">
 
              <img src={HomePageAssets.icon2} alt="Calendar"  />
  
          </div>
          {/* Main heading and subtitle */}
          <h1 className="text-5xl md:text-8xl  leading-tight mb-4 lg:hidden" style={{ fontFamily: 'Funnel Display, sans-serif' }} >
            More gigs.<br /> Bigger crowds. Instant payouts.
          </h1>
          <h1 className="text-5xl md:text-8xl  leading-tight mb-4 hidden lg:block" style={{ fontFamily: 'Funnel Display, sans-serif' }}>
            More gigs. Bigger crowds. <br />  Instant payouts.
          </h1>
          <p className="text-[#BEBEBE] text-lg md:text-2xl   lg:hidden  mb-4">
            Artists and DJs discover gigs, build their teams, and grow their fans — all in one app.
          </p>
          <p className="text-[#BEBEBE] text-lg md:text-2xl  lg:text-3xl  mb-4 hidden lg:block">
            Artists and DJs discover gigs, build their teams, and grow their fans<br /> all in one app
          </p>
        </div>
        {/* App store button */}
        <p className="text-purple-400 text-lg mb-1 lg:mt-4">Available on</p>
        <a   target="_blank"  data-umami-event="Download App Banner"
              href="https://apps.apple.com/us/app/musicade/id6747211062?uo=4"
             
              rel="noopener noreferrer"   className="inline-block" style={{zIndex:2}}>
          <img src={HomePageAssets.appleBadge} alt="App Store Badge" className=" inline-block  " />
        </a>
        {/* 3 phones */}
        <div className="flex justify-center w-full ml-[40vw] -mt-[2.5rem] md:ml-0 md:mt-2  md:px-6 lg:mt-16" >
          <img
            src={HomePageAssets.image1}
            alt="Phone mockup"
            className="max-w-none w-[290vw] md:w-[800px] lg:w-[90rem] drop-shadow-[0_0_80px_rgba(255,255,255,0.15)] rounded-[28px]"
          />
        </div>
      </section>

      {/* DISCOVER TALENT */}
      <section ref={discoverSection.ref} className={`relative flex flex-col mt-[-5vh] md:flex-row items-start  lg:pr-0  md:py-32 gap-8 md:gap-0 ${discoverSection.isVisible ? 'scroll-animate-left' : ''}`}>
        <div className="md:w-1/2  md:pr-16 flex flex-col  text-start  px-6   " style={{zIndex:2}}>
          <p className="text-[#FF8972] text-xl md:text-lg  lg:text-lg mb-2 md:mb-4 md:ml-[10%]   xl:text-[2.2rem] xl:ml-[48%]" style={{zIndex:2}}>Why Musicade?</p>
          <h2 className="text-6xl md:text-[84px] lg:text-8xl  md:ml-[10%] lg:text-[96px] xl:text-[120px] xl:ml-[48%]  leading-[1.05] md:leading-[1.05] mb-2 md:mb-4 text-left" style={{ fontFamily: 'Funnel Display, sans-serif',zIndex:2 }}>
            Discover
          
            <span className="block mt-2">Talent</span>
          </h2>
          <p className="text-[#BEBEBE]  text-[23px] md:text-2xl lg:text-3xl md:mt-2 md:ml-[10%] xl:text-[1.8rem] xl:ml-[48%] " style={{zIndex:2}}>Find local DJs, artists, and crews to build your next show, set, or collaboration.</p>
        </div>
        <div className="w-full md:w-1/2 ml-[9rem]  md:ml-0 mt-[-18vh] flex justify-end relative xl:mt-[-230px]">
          <img
            src={HomePageAssets.image9}
            alt="Phone mockup"
            className="max-w-none w-[18.88rem] md:w-[500px] md:ml-3 lg:w-[760px] xl:w-[990px] rotate-1 drop-shadow-[0_0_40px_rgba(255,255,255,0.25)] lg:-mt-16 md:mr-[-20px] lg:mr-[-20px] xl:mr-[-20px] hidden md:block"
     
          />

            <img
            src={HomePageAssets.image17}
            alt="Phone mockup"
            className="md:hidden  max-w-none w-[35rem]  lg:w-[45rem] rotate-1 drop-shadow-[0_0_40px_rgba(255,255,255,0.25)] "
       
          />


          

        </div>
      </section>

      {/* EASY ACCESS */}
      <section ref={easyAccessSection.ref} className={`flex flex-col md:flex-row-reverse items-start  md:px-24  -mt-[8rem] md:-mt-[11rem] ${easyAccessSection.isVisible ? 'scroll-animate-right' : ''}`}>
        <div className="md:w-1/2 px-6" style={{zIndex:2}}>
          <h2 className="text-5xl md:text-7xl lg:text-8xl  leading-tight mb-1" style={{ fontFamily: 'Funnel Display, sans-serif'}}>Sell Tickets With Ease</h2>
          <p className="text-[#BEBEBE]  text-[23px] md:text-2xl lg:text-3xl">Publish your event, share your link, and track ticket sales in seconds.</p>
        </div>
        <div className="w-max md:w-1/2 -mt-[7rem] md:-mt-[15rem]">
          <img src={HomePageAssets.image10} alt="Sell tickets with ease" className="max-w-none w-[55rem] -ml-[19rem] md:w-[60rem] md:-ml-[29rem] lg:w-[90rem]  lg:-ml-[25rem] lg:-mt-[20rem] -rotate-3 drop-shadow-[0_0_40px_rgba(255,255,255,0.25)]" />
        </div>
      </section>

      {/* SUPPORT CREATORS */}
      <section ref={supportCreatorsSection.ref} className={`flex flex-col md:flex-row items-start  md:px-24 -mt-[3rem] ${supportCreatorsSection.isVisible ? 'scroll-animate-left' : ''}`}>
        <div className="md:w-1/2 px-6" style={{zIndex:2}}>
          <h2 className="text-5xl md:text-7xl lg:text-8xl  leading-tight mb-1 lg:hidden"  style={{ fontFamily: 'Funnel Display, sans-serif' }}>Grow Together. Win Together.</h2>
          <h2 className="text-5xl md:text-7xl lg:text-8xl  leading-tight mb-1 hidden lg:block" style={{ fontFamily: 'Funnel Display, sans-serif' }}>Grow Together. <br /> Win Together.</h2>
          <p className="text-[#BEBEBE]  text-[23px] md:text-2xl lg:text-3xl" >Work with artists in your city — every connection and collab builds a stronger community.</p>
        </div>
        <div className="w-max md:w-1/2  md:-mt-[8rem]">
          <img src={HomePageAssets.image11} alt="Grow together" className="max-w-none w-[30rem] -ml-7 md:w-[45rem] md:-ml-[11rem] lg:w-[80rem] lg:-ml-[26rem]" />
        </div>
      </section>

      {/* DREAM TEAM */}
      <section ref={dreamTeamSection.ref} className={`flex flex-col md:flex-row-reverse items-start  md:px-24 mt-12 lg:mt-[11rem] ${dreamTeamSection.isVisible ? 'scroll-animate-right' : ''}`}>
        <div className="md:w-1/2 px-6" style={{zIndex:2}}>
          <h2 className="text-6xl md:text-4xl lg:text-8xl    leading-tight mb-1" style={{ fontFamily: 'Funnel Display, sans-serif'}}>Build your dream team</h2>
          <p className="text-[#BEBEBE]  text-[23px] md:text-2xl lg:text-3xl">Find verified DJs, artists, photographers, hosts, and crew members — and lock in talent for your next show or project.</p>
        </div>
        <div className="md:w-1/2 ">
          <img src={HomePageAssets.image12} alt="Build your dream team" className="max-w-none w-[32rem] md:w-[45rem] md:-ml-[13rem] md:-mt-[6rem] lg:w-[85rem] lg:-ml-[19rem] xl:-ml-[13rem] lg:-mt-[12rem]  hidden md:block" />
          <img src={HomePageAssets.image15} alt="Build your dream team" className="max-w-none w-[28rem]  ml-[4rem] md:w-[460px] md:hidden" />
        </div>
      </section>

      {/* ARTIST PROFILE */}
      <section ref={artistProfileSection.ref} className={`flex flex-col md:flex-row items-start md:px-24 md:mt-[8rem] md:gap-4 ${artistProfileSection.isVisible ? 'scroll-animate-up' : ''}`}>
        <div className="md:w-1/2  px-6">
          <h2 className="text-5xl md:text-5xl  leading-tight mb-1 md:hidden" style={{ fontFamily: 'Funnel Display, sans-serif', zIndex: 2 }}>Show your<br />work. Name<br />your price</h2>
          <h2 className="text-5xl md:text-5xl lg:text-8xl  leading-tight mb-1 hidden md:block" style={{ fontFamily: 'Funnel Display, sans-serif', zIndex: 2 }}>Show your work. Name your price</h2>
          <p className="text-[#BEBEBE] text-[23px] md:text-2xl lg:text-3xl lg:mt-3" style={{ zIndex: 2 }}>Your profile is your storefront, promote your skills, set your rates, and get booked by people who value what you do.</p>
        </div>
        <div className="md:w-1/2 flex  ">
          <img src={HomePageAssets.image13} alt="Artist profile" className="max-w-none w-[56rem] -ml-[12.2rem] rotate-[25deg] md:rotate-0 md:w-[36rem] md:-mt-[7rem] lg:w-[70rem] lg:-ml-[20rem] lg:-mt-[12rem]" />
        </div>
      </section>

      {/* GET PAID */}
      <section ref={getPaidSection.ref} className={`flex flex-col md:flex-row-reverse items-start  md:px-24 mt-10 md:mt-[10rem] lg:mt-[15rem] ${getPaidSection.isVisible ? 'scroll-animate-left' : ''}`}>
        <div className="md:w-1/2 px-6">
          <p className="text-green-400 text-xl lg:text-4xl mb-2">No waiting</p>
          <h2 className="text-5xl md:text-5xl lg:text-8xl   leading-tight mb-1" style={{ fontFamily: 'Funnel Display, sans-serif', zIndex: 2 }}>Get paid Instantly.</h2>
          <p className="text-[#BEBEBE] text-[23px] md:text-2xl lg:text-3xl" style={{ zIndex: 2 }}>Launch your event on Musicade and receive payouts the moment tickets go live — fast, secure, and transparent.</p>
        </div>
        <div className="md:w-1/2 ">
          <img src={HomePageAssets.image14} alt="Get paid instantly" className="max-w-none md:w-[35rem] md:-ml-[7rem] md:-mt-[7rem] lg:w-[65rem] lg:-ml-[7rem] lg:-mt-[15rem]  hidden md:block" />
          <img src={HomePageAssets.image16} alt="Get paid instantly" className="max-w-none w-[28rem]  ml-[3rem]  md:w-[460px] md:hidden" />
        </div>
      </section>

      {/* FINAL GRID SECTION */}
      <section ref={gridSection.ref} className={`px-6 md:px-24 mt-6 lg:mt-[10rem] ${gridSection.isVisible ? 'scroll-animate-scale' : ''}`}>
        <div className="grid grid-cols-1 md:grid-cols-2 grid-rows-2 gap-8 lg:gap-12">
          {/* Purple card with text */}
          <div className="bg-[#4B2BAE] rounded-[48px] p-8 lg:p-10 flex flex-col justify-center h-full md:h-[420px] min-h-[300px] lg:h-[50rem]">
            <p className="text-purple-200 text-2xl md:text-1xl lg:text-3xl mb-4 lg:mb-8" style={{fontFamily: 'Funnel Display, sans-serif', zIndex: 2}}>From open mics to festivals</p>
            <h2 className="text-5xl md:text-4xl lg:text-8xl   leading-tight text-white" style={{fontFamily: 'Funnel Display, sans-serif', zIndex: 2}}>
              Musicade brings<br />your city's<br />sound to your<br />fingertips.
            </h2>
          </div>
          {/* Main image right of card */}
          <img src={HomePageAssets.image6} alt="Music event" className="rounded-[48px] w-full h-full object-cover md:h-[420px] min-h-[300px] lg:h-[50rem]  " />
          {/* Two images below, side by side on lg */}
          <img src={HomePageAssets.image7} alt="Live performance" className="rounded-[48px] w-full h-[420px] object-cover" />
          <img src={HomePageAssets.image8} alt="DJ performance" className="rounded-[48px] w-full h-[420px] object-cover" />
        </div>
      </section>

      {/* FINAL CTA */}
      <section ref={finalCTASection.ref} className={`text-center py-20 px-6 lg:py-0 ${finalCTASection.isVisible ? 'scroll-animate-up' : ''}`}>
        <h2 className="text-6xl md:text-7xl mb-4 lg:hidden" style={{ fontFamily: 'Funnel Display, sans-serif' }}>Your City. <br />Your Stage.</h2>
        <h2 className="text-6xl md:text-7xl lg:text-8xl mb-4 hidden lg:block" style={{ fontFamily: 'Funnel Display, sans-serif' }}>Your City. Your Stage.</h2>
        <p className="text-[#BEBEBE]  text-[23px] md:text-2xl lg:text-3xl mb-8">Download Musicade and step into the local music scene — where artists and DJs grow, connect, and get booked.</p>

        <p className="text-purple-400 text-lg mb-1">Available on</p>
        <a      href="https://apps.apple.com/us/app/musicade/id6747211062?uo=4"   data-umami-event="Download App Footer" target="_blank" rel="noopener noreferrer" className="inline-block">
          <img src={HomePageAssets.appleBadge} alt="App Store Badge" className=" inline-block  " />
        </a>
      </section>

      <footer className="text-center py-8 text-gray-500 text-sm lg:mt-[4rem]" >© copyright 2025 Musicade</footer>
      </div>
    </div>
  );
}
 